import { render, staticRenderFns } from "./warning-list.vue?vue&type=template&id=5026f20a&scoped=true&"
import script from "./warning-list.vue?vue&type=script&lang=js&"
export * from "./warning-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5026f20a",
  null
  
)

export default component.exports